function inObject(find: any, obj: Record<string, any>): boolean {
    for (const prop in obj) {
        if (obj[prop] === find) {
            return true;
        }
    }

    return false;
}

// ----------------------------------------------------------------------------

export default inObject;
